module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Fireplace-d592423ebacc6e50b75bce74ecff18c7.svg";